const MAGICKINGDOMLANDS = [
    {
        name: 'Adventureland',
        rides: [
            {
                name: 'Jungle Cruise',
                count: 0,
            },
            {
                name: 'Pirates of the Caribbean',
                count: 0,
            },
            {
                name: 'Swiss Family Treehouse',
                count: 0,
            },
            {
                name: 'The Magic Carpets of Aladdin',
                count: 0,
            },
            {
                name: "Walk Disney's Enchanted Tiki Room",
                count: 0,
            }
        ]
    },

    {
        name: 'Fantasyland',
        rides: [
            {
                name: "It's a Small World",
                count: 0,
            },
            {
                name: 'Dumbo the Flying Elephant',
                count: 0,
            },
            {
                name: 'Enchanted Tales with Belle',
                count: 0,
            },
            {
                name: 'Mad Tea Party',
                count: 0,
            },
            {
                name: 'Meet Ariel at Her Grotto',
                count: 0,
            },
            {
                name: "Mickey's PhilharMagic",
                count: 0,
            },
            {
                name: "Peter Pan's Flight",
                count: 0,
            },
            {
                name: 'Seven Dwarfs Mine Train',
                count: 0,
            },
            {
                name: 'The Barnstormer',
                count: 0,
            },
            {
                name: 'The Many Adventures of Winnie the Pooh',
                count: 0,
            },
            {
                name: 'Under the Sea ~ Journey of the Little Mermaid',
                count: 0,
            }
        ]
    },
    
    {
        name: 'Frontierland',
        rides: [
            {
                name: 'Big Thunder Mountain Railroad',
                count: 0,
            },
            {
                name: 'Country Bear Jamboree',
                count: 0,
            },
            {
                name: "Frontierland Shootin' Arcade",
                count: 0,
            },
            {
                name: 'Splash Mountain',
                count: 0,
            },
            {
                name: 'Tom Sawyer Island',
                count: 0,
            }
        ]
    },

    {
        name: 'Liberty Square',
        rides: [
            {
                name: 'Liberty Square Riverboat',
                count: 0,
            },
            {
                name: 'Hall of Presidents',
                count: 0,
            },
            {
                name: 'The Haunted Mansion',
                count: 0,
            }
        ]
    },

    {
        name: "Main Street U.S.A",
        rides: [
            {
                name: 'Flag Retreat',
                count: 0,
            },
            {
                name: 'See Mickey at Town Square Theater',
                count: 0,
            },
        ]
    },

    {
        name: 'Tomorrowland',
        rides: [
            {
                name: 'Astro Orbitor',
                count: 0,
            },
            {
                name: "Buzz Lightyear's Space Ranger Spin",
                count: 0,
            },
            {
                name: 'Monsters, Inc. Laugh Floor',
                count: 0,
            },
            {
                name: 'Space Mountain',
                count: 0,
            },
            {
                name: 'Tomorrowland Speedway',
                count: 0,
            },
            {
                name: 'Peoplemover',
                count: 0,
            },
            {
                name: "Walt Disney's Carousel of Progress",
                count: 0,
            }
        ]
    }
]

export default MAGICKINGDOMLANDS;